function topic_volcano(){
    var url = 'https://dmip2023.colife.org.tw/'
    var pointsCollection = []
    var points = [{
        name: "小油坑",
        lon: 121.544,
        lat: 25.176
    }, {
        name: "大油坑",
        lon: 121.576,
        lat: 25.169
    }, {
        name: "七星山",
        lon: 121.553,
        lat: 25.169
    }]
    points.forEach(el => {
        backgroud_layer_control(`火山(${el.name})`);
        pointsCollection.push(turf.point([el.lon, el.lat], {name: el.name}))
    })
    $("#home4 .card-body").html(
        slider_card_component_create({
			"cardhead": "監控資料追蹤",
			"cardbody": data_source_table_html("火山觀測")
		}, false) +
		'<div class="row">' +
            '<div class="col-12 mb-1">' +
            slider_card_component_create({
                "cardhead": "火山活動監測(NCDR)",
                "cardbody": `
                    <div class="col-12">
                        <button class="btn btn-success btn-sm mb-2 py-0 mr-2" type="button" id="volcano-observation-dialog">放大檢視</button>
                        <button class="btn btn-primary btn-sm mb-2 py-0" type="button" id="volcano-observation-new-page">另開分頁</button>
                        <iframe src="${url}" class="w-100" frameborder="0" title="火山活動監測" style="height: calc(100vh - 280px);"></iframe>
                    </div>`
            }) +
            // slider_card_component_create({
            //     "cardhead": "火山位置分布",
            //     "cardbody": `
            //         <div class="col-12">
            //             <table class="table table-sm table-bordered">
            //                 <thead class="thead-dark">
            //                     <tr>
            //                         <th>名稱</th>
            //                         <th>位置</th>
            //                     </tr>
            //                 </thead>
            //                 <tbody>
            //                     <tr>
            //                         <th>小油坑</th>
            //                         <th>位置</th>
            //                     </tr>
            //                     <tr>
            //                         <th>大油坑</th>
            //                         <th>位置</th>
            //                     </tr>
            //                     <tr>
            //                         <th>七星山</th>
            //                         <th>位置</th>
            //                     </tr>
            //                 </tbody>
            //             </table>
            //         </div>`
            // }) +
            '</div>' +    
		'</div>'
	)
    $("#volcano-observation-dialog").click(function(){
        modal_open(`
            <iframe src="${url}" class="w-100" frameborder="0" title="火山活動監測" style="height: calc(100vh - 180px);"></iframe>`,
            "火山活動監測"
        )
    })
    $("#volcano-observation-new-page").click(function(){
        window.open(url, '_blank')
    })
    overlay_dataset["火山點位"] = L.geoJSON(turf.featureCollection(pointsCollection), {
        onEachFeature: function(feature, layer){
            layer.bindTooltip(feature.properties.name, {
                sticky: true,
                opacity: .8,
                permanent: true, 
                // direction:"center",
                // className: 'leaflet-tooltip-own' 
            })
        }
    }).addTo(map)
    map.setView({lat: 25.186042724373426, lng: 121.51222229003908}, 12)
}
